/**
 * Streak-flame-filled: the streak-flame stack painted solid — the front
 * flames cover the ones behind, so the three color slots read as three
 * nested silhouettes. Same shared fire motion on every layer (see
 * StreakFlameBase and fireMotion.js).
 *
 * Color slots: 0 the big back flame, 1 the middle one, 2 the front one.
 */import*as React from"react";import StreakFlameBase from"web/shared/icons/glyphs/StreakFlameBase";import{jsx as _jsx}from"react/jsx-runtime";function StreakFlameFilledGlyph(props){return/*#__PURE__*/_jsx(StreakFlameBase,{progress:props.progress,colors:props.colors,filled:true});}export default StreakFlameFilledGlyph;